module.exports = {
  OPENTOK_API_KEY: process.env.REACT_APP_OPENTOK_API_KEY || '46723182',
  API_URL:process.env.REACT_APP_API_URL || 'https://api.evisita.local:1800/api/',
  STATIC_FILES_URL: process.env.REACT_APP_STATIC_FILES_URL || 'https://s0000/static/uploads/',
  DEFAULT_LOCALE:process.env.REACT_APP_DEFAULT_LOCALE || 'es-ES' ,
  SUPPORT_PHONE:process.env.REACT_APP_SUPPORT_PHONE || '915981422',
  SUPPORT_EMAIL:process.env.REACT_APP_SUPPORT_EMAIL || 'gedeonrichter@i-konekt.com',
  DISABLE_NETWORK_TEST:process.env.REACT_APP_DISABLE_NETWORK_TEST || true,
};
